'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _roles = require('config/permissions/roles');

var _reports = require('./reports.component');

var _reports2 = _interopRequireDefault(_reports);

var _adminsByCategoryArea = require('./admins-by-category-area/admins-by-category-area.module');

var _adminsByCategoryArea2 = _interopRequireDefault(_adminsByCategoryArea);

var _adminsByCategoryBar = require('./admins-by-category-bar/admins-by-category-bar.module');

var _adminsByCategoryBar2 = _interopRequireDefault(_adminsByCategoryBar);

var _adminsByCategoryPie = require('./admins-by-category-pie/admins-by-category-pie.module');

var _adminsByCategoryPie2 = _interopRequireDefault(_adminsByCategoryPie);

var _adminTrend = require('./admin-trend/admin-trend.module');

var _adminTrend2 = _interopRequireDefault(_adminTrend);

var _ingredientRisk = require('./ingredient-risk/ingredient-risk.module');

var _ingredientRisk2 = _interopRequireDefault(_ingredientRisk);

var _reportForm = require('./report-form/report-form.module');

var _reportForm2 = _interopRequireDefault(_reportForm);

var _riskByYear = require('./risk-by-year/risk-by-year.module');

var _riskByYear2 = _interopRequireDefault(_riskByYear);

var _seriousRiskByYear = require('./serious-risk-by-year/serious-risk-by-year.module');

var _seriousRiskByYear2 = _interopRequireDefault(_seriousRiskByYear);

var _systemMetrics = require('./system-metrics/system-metrics.module');

var _systemMetrics2 = _interopRequireDefault(_systemMetrics);

require('./reports.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.reports', [_angularUiRouter2.default, _adminsByCategoryArea2.default, _adminsByCategoryBar2.default, _adminsByCategoryPie2.default, _adminTrend2.default, _ingredientRisk2.default, _reportForm2.default, _riskByYear2.default, _seriousRiskByYear2.default, _systemMetrics2.default]).component('reports', _reports2.default).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('reports', {
    parent: 'app',
    url: '/reports',
    component: 'reports',
    data: {
      permissions: {
        only: [_roles.SYS_ADMIN],
        redirectTo: 'dashboard'
      }
    },
    resolve: {
      reportTypes: function reportTypes(ReportService) {
        return ReportService.getReportTypes().filter(function (r) {
          return r.enabled;
        }).sort(function (a, b) {
          var nameA = a.name.toLowerCase();
          var nameB = b.name.toLowerCase();
          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
          return 0;
        });
      },
      flex: function flex() {
        return '100';
      },
      layout: function layout() {
        return 'column';
      }
    }
  });
}).name;


// WEBPACK FOOTER //
// ./components/app/reports/reports.module.js